import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { SectionIdentifier, SectionMessage } from '../review-section.domain';
// import ResizeObserver from 'resize-observer-polyfill';

@Component({
  selector: 'app-review-message-container',
  templateUrl: './review-message-container.component.html',
  styleUrls: ['./review-message-container.component.scss'],
})
export class ReviewMessageContainerComponent implements OnInit, AfterViewInit {
  _sectionMessages: SectionMessage[];
  // observer: ResizeObserver;

  constructor() {}

  @ViewChild('messageSection') messageSection: ElementRef;
  @Input() applicationId: number;
  @Input() sectionId: SectionIdentifier;
  @Input() entityId: number | null;
  @Input() set sectionMessages(value: SectionMessage[]) {
    this._sectionMessages = value;
  }
  @Input() allowCreateMessage: boolean = true;

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // this.scrollToBottom();
  }

  getIconSrc(message: SectionMessage): string {
    const gender = message.title?.toLocaleLowerCase() === 'mrs' ? 'female' : 'male';
    const role = message.role;
    const imageType =
      role === 'standard_technician' || role === 'guest_technician'
        ? 'technic'
        : role === 'customer'
        ? 'customer'
        : role === 'employee' || role === 'administrator'
        ? 'admin'
        : 'user';

    return `assets/images/${imageType}_${gender}.png`;
  }

  onMessageAdded() {
    // this.scrollToBottom();
  }

  // private scrollToBottom() {
  //   if (!this.messageSection?.nativeElement) return;

  //   this.observer = new ResizeObserver(() => {
  //     this.messageSection.nativeElement.scrollTop += this.messageSection.nativeElement.scrollHeight;
  //   });

  //   this.observer.observe(this.messageSection.nativeElement);
  // }
}
